import {
  DashboardOutlined,
  GlobalOutlined,
  ImportOutlined,
  CarOutlined,
  UserOutlined,
  ApartmentOutlined,
  FileTextOutlined,
  SafetyOutlined,
  TeamOutlined,
  AimOutlined,
  EnvironmentOutlined,
  ShareAltOutlined
} from '@ant-design/icons';

const icons = {
  DashboardOutlined,
  GlobalOutlined,
  ImportOutlined,
  CarOutlined,
  UserOutlined,
  ApartmentOutlined,
  FileTextOutlined,
  SafetyOutlined,
  TeamOutlined,
  AimOutlined,
  EnvironmentOutlined,
  ShareAltOutlined
};

const dashboard = {
  id: 'group-dashboard',
  title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: icons.DashboardOutlined,
      breadcrumbs: false,
      permission: 'dashboard:read'
    },
    {
      id: 'tours',
      title: 'Каталог туров',
      type: 'item',
      url: '/tours',
      icon: icons.GlobalOutlined,
      breadcrumbs: false,
      permission: 'tours:read'
    },
    {
      id: 'map',
      title: 'Карта туров',
      type: 'item',
      url: '/map',
      icon: icons.AimOutlined,
      breadcrumbs: false,
      permission: 'tours:read'
    },
    {
      id: 'locations',
      title: 'Достопримечательности',
      type: 'item',
      url: '/locations',
      icon: icons.EnvironmentOutlined,
      breadcrumbs: false,
      permission: 'tours:read'
    },
    {
      id: 'pipeline',
      title: 'Пайплайн',
      type: 'item',
      url: '/pipeline',
      icon: icons.ApartmentOutlined,
      breadcrumbs: false,
      permission: 'pipeline:read'
    },
    {
      id: 'drivers',
      title: 'Водители',
      type: 'item',
      url: '/drivers',
      icon: icons.CarOutlined,
      breadcrumbs: false,
      permission: 'drivers:read'
    },
    {
      id: 'participants',
      title: 'Участники',
      type: 'item',
      url: '/participants',
      icon: icons.UserOutlined,
      breadcrumbs: false,
      permission: 'users:read'
    },
    {
      id: 'telegram',
      title: 'Telegram Import',
      type: 'item',
      url: '/telegram',
      icon: icons.ImportOutlined,
      breadcrumbs: false,
      permission: 'telegram:write'
    },
    {
      id: 'vk',
      title: 'VK Import',
      type: 'item',
      url: '/vk',
      icon: icons.ShareAltOutlined,
      breadcrumbs: false,
      permission: 'vk:write'
    },
    {
      id: 'admins',
      title: 'Админы',
      type: 'item',
      url: '/admins',
      icon: icons.SafetyOutlined,
      breadcrumbs: false,
      permission: 'admins:read'
    },
    {
      id: 'roles',
      title: 'Роли',
      type: 'item',
      url: '/roles',
      icon: icons.TeamOutlined,
      breadcrumbs: false,
      permission: 'roles:read'
    },
    {
      id: 'telegram-templates',
      title: 'Шаблоны уведомлений',
      type: 'item',
      url: '/telegram/templates',
      icon: icons.FileTextOutlined,
      breadcrumbs: false,
      permission: 'templates:read'
    }
  ]
};

export default dashboard;
